import { useCallback, useRef } from 'react'
import { useThrottledCallback } from 'use-debounce'
import { LiveMessageBlock, ParsedBlock } from '../chat-data/types'
import { useXMPPClientContext } from '../xmpp-client/XMPPClientContext'
import { BlockOrCompositeBlock } from '../components/compositeBlocks'

export const useMarkLatestVisibleEvent = (
  userMarkingId: string,
  events: Array<BlockOrCompositeBlock | ParsedBlock>
) => {
  const {
    client: { markEvent },
  } = useXMPPClientContext()

  const eventsToRead = useRef<Array<LiveMessageBlock>>([])
  const throttledMarkEvent = useThrottledCallback(
    () => {
      const latestEvent = eventsToRead.current.reduce((latest, event) => {
        if (!latest || events.indexOf(event) > events.indexOf(latest)) {
          return event
        }
        return latest
      })
      eventsToRead.current = []
      if (latestEvent) {
        markEvent(latestEvent.roomId, latestEvent.id ?? '', 'displayed').catch(console.error)
      }
    },
    1000,
    { leading: false }
  )

  const handleLastVisibleEvent = useCallback(
    (event: LiveMessageBlock) => {
      const isUnreadByCurrentUser = event.statuses[userMarkingId] === undefined
      const roomId = event.roomId
      const isOwnMessage = event.author === userMarkingId
      if (roomId && isUnreadByCurrentUser && !isOwnMessage) {
        eventsToRead.current.push(event)
        throttledMarkEvent()
      }
    },
    [userMarkingId, throttledMarkEvent]
  )

  return { handleLastVisibleEvent }
}
